import { _addStoreHandlers, } from '../service/store';
import { _$id, _addEventListener, } from '../util/dom';
const _addUnitChangeHandler = (handler) => {
    _unitChangeHandlers.push(handler);
}, _currentUnitAbbr = () => _currentUnitAbbrCell, _currentUnitConversion = () => _currentConversionCell, _selectDistanceUnit = (unitAbbr) => {
    const unitButtonId = `rm-du-${unitAbbr}`, $unitButton = _$id(unitButtonId);
    $unitButton.click();
}, _setDistanceUnit = (clickEvent) => {
    const $target = clickEvent.target;
    if (!($target instanceof HTMLInputElement)) {
        return;
    }
    const unitAbbr = $target.value;
    _currentUnitAbbrCell = unitAbbr;
    _currentConversionCell = _conversions[unitAbbr];
    _handleUnitChange();
}, _handleUnitChange = () => {
    for (const handler of _unitChangeHandlers) {
        handler();
    }
}, _metersPerMile = 1609.344, _metersPerKm = 1000, _conversions = {
    mi: _metersPerMile,
    km: _metersPerKm,
}, _unitChangeHandlers = [], _$duForm = _$id('distance-units');
let _currentUnitAbbrCell = 'mi', _currentConversionCell = _metersPerMile;
_selectDistanceUnit(_currentUnitAbbrCell);
_addEventListener(_$duForm, 'click', _setDistanceUnit);
_addStoreHandlers('u', _selectDistanceUnit, _currentUnitAbbr);
export { _addUnitChangeHandler, _currentUnitAbbr, _currentUnitConversion, };
